export default "__VITE_ASSET__DywuDY9f__"